import "Scripts/cart-notification.js"
import "Scripts/navigation.js"
import "Scripts/predictive-search.js"
import "Scripts/cart.js"
//import "../../../../src/assets/vendor/js/instafeed"
import "../language-selector.js"

import "Styles/layout/theme.scss";
import "Styles/swiper.min.css"

import instafeedEs from "instafeed.js";

window.getInstafeed = (token, sectionId) => {
    return new instafeedEs({
      accessToken: token,
      limit: 4,
      target: 'instafeed-' + sectionId,
      template: `<div class="post"><div class="image-wrapper"><img src="{{image}}" alt="{{caption}}" loading="lazy" /></div></div>`
    });
}


//Gradient Tracking Button
let btn = document.querySelectorAll('.orange-tracking');

if (btn) {
  btn.forEach(element => {
    element.addEventListener('mousemove', e => {
      let rect = e.target.getBoundingClientRect();
      let x = e.clientX - rect.left;
      let y = e.clientY - rect.top;
      element.style.setProperty('--x', x + 'px');
      element.style.setProperty('--y', y + 'px');
    });
  });
}

//Gradient Tracking Button = submit
let submitbtn = document.querySelector('button[type="submit"]');
if (submitbtn){
  submitbtn.addEventListener('mousemove', e => {
    let rect = e.target.getBoundingClientRect();
    let x = e.clientX - rect.left;
    let y = e.clientY - rect.top;
    submitbtn.style.setProperty('--x', x + 'px');
    submitbtn.style.setProperty('--y', y + 'px');
  });
}

window.addEventListener('load', () => {
  // accordions
  let accordions = document.getElementsByClassName("accordion-title");
  for (let i = 0; i < accordions.length; i++) {
    accordions[i].onclick = function() {
      this.classList.toggle("--active");
      this.nextElementSibling.classList.toggle("--active");
    }
  }

 
let observer = new MutationObserver(() => {
  let accordions = document.getElementsByClassName("availability-title");
  for (let i = 0; i < accordions.length; i++) {
    accordions[i].onclick = function() {
      this.classList.toggle("--active");
      this.nextElementSibling.classList.toggle("--active");
    }
  }
});

// Start observing the document with the configured parameters
observer.observe(document, { childList: true, subtree: true });
  

})

// Hero Carousel
document.addEventListener("DOMContentLoaded", function (event) {
  var heroSwiper = new Swiper('.hero-carousel', {
    pagination: {
      el: ".swiper-pagination",
      type: 'custom',
      renderCustom: function (heroSwiper, current, total) {
        return ('0' + current).slice(-2) + '/' + ('0' + total).slice(-2); },
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    autoplay: {
      delay: 7000,
    },
    autoHeight: true,
    effect: 'slide',
  });

  const isTouchDevice = () => {
    return true == ("ontouchstart" in window || window.DocumentTouch && document instanceof DocumentTouch);
  }

  if (isTouchDevice()) {
    this.body.classList.add('touch-device');
  }

  let searchContainer = document.querySelector('.predictive-search');
  let searchField = document.getElementById('Search');
  let navigation = document.querySelector('#siteNavigation .desktop');
  document.querySelectorAll('.predictive-search__toggle').forEach((el) => {
    el.addEventListener('click', (e) => {
      e.preventDefault();
      if (isTouchDevice()) {
        searchField.value = "";
        searchField.focus();
      } else {
        if (!searchContainer.classList.contains('--active')) {
          searchContainer.classList.add('--active');
          searchField.focus();
          navigation.classList.add('--hidden');
        } else {
          searchField.value = "";
          searchField.dispatchEvent(new Event('input'));
          searchContainer.classList.remove('--active');
          navigation.classList.remove('--hidden');
        }
      }
    });
  });

  // let searchSidebar = document.querySelector('#cloud_search_filters_sidebar').closest('.side-bar');
  // searchSidebar.style.display = 'none';

});

// Product Card Varint Image hover

document.addEventListener('mouseenter', (e) => {
  if (e.target.classList && e.target.classList.contains('card__variants__thumb')) {
    let variantName = document.getElementById('variant-name-' + e.target.dataset.productId);
    variantName.innerHTML = e.target.dataset.variantName;

    let variantImage = document.getElementById('variant-photo-' + e.target.dataset.productId);
    if (e.target.dataset.variantImage && variantImage) variantImage.src = e.target.dataset.variantImage;
  }

}, true);

// Product variant title change based on selection

let optionCont = document.querySelectorAll('.product-form__input');
optionCont.forEach((elem) => {
  let titleCont = elem.querySelector('.title span');
  let radioOptions = elem.querySelectorAll('.product__variant-selector input');
  let selectedRadio = elem.querySelector('input:checked');
  document.addEventListener('DOMContentLoaded', function() {
    if(titleCont) {
      titleCont.innerHTML = selectedRadio.value;
    }
  })
  for (let index = 0; index < radioOptions.length; index++) {
    const option = radioOptions[index];
    option.addEventListener("change", function(event) {
      var item = event.target.value;
      if(titleCont) {
        titleCont.innerHTML = item;
      }
    });
  }
});
